import React, { useEffect, useState } from "react";
import "./Style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { UseMetaData } from "../../Pages/PostMortems";
import Error from "../../Components/Error/Error";
import PostmortemsTable from "../../Components/PostmortemsTable/PostmortemsTable";
import PostmortemFilters from "../../Components/PostmortemsTable/PostmortemFilters";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserInfo from "../../context/UserAccessContext";
import { getApiErrorPresentation } from "../../Utils/apiErrorPresentation";

const PostmortemsPage = () => {
  const location = useLocation();

  const {
    dataLoading,
    tableData,
    dataError,
    setPg,
    setPgSize,
    pg,
    pgSize,
    totalData,
    refetchPostmortems,
    handleSorting,
    filters,
    setFilters,
    userAccessLoading,
    userAccessError,
    generateArrayForTable,
    setTableData,
  } = UseMetaData(location);

  const navigate = useNavigate();
  const [dataForTable, setDataForTable] = useState([]);

  const { userIsAdmin } = UserInfo();

  const updateFilters = (nextFilters) => {
    setPg(1);
    setFilters(nextFilters);
  };

  const updatePageSize = (nextPageSize) => {
    setPg(1);
    setPgSize(nextPageSize);
  };

  const pageLabel = location.state?.ongoing
    ? "Ongoing Postmortems"
    : location.state?.archived
    ? "Archived Post-mortems"
    : "Ongoing Post-mortems";

  useEffect(() => {
    setDataForTable(tableData);
  }, [tableData]);

  const tableIsLoading = dataLoading || (userAccessLoading && dataForTable.length === 0);
  const errorPresentation = dataError ? getApiErrorPresentation(dataError) : null;

  return (
    <div className="pm-page-wrapper">
      {dataError ? (
        <Error
          {...errorPresentation}
          onRetry={errorPresentation.retryable ? refetchPostmortems : undefined}
          retrying={dataLoading}
        />
      ) : (
        <div className="pm-page-content">
          <ToastContainer />

          <nav className="mds-breadcrumb pm-breadcrumb">
            <ol>
              <li>
                <a onClick={() => navigate("/")} className="pm-breadcrumb-link">
                  Home
                </a>
              </li>
              <li>{pageLabel}</li>
            </ol>
          </nav>

          <PostmortemFilters
            filters={filters}
            priorities={["0", "1", "2", "3", "4"]}
            statuses={["DRAFT", "LEADERSHIP_REVIEW"]}
            onChange={updateFilters}
            onClear={() => updateFilters({ priority: [], status: [], ci: "", causedByCi: "", portfolio: "", incidentId: "" })}
          />

          <div
            className={
              location?.state?.incidentID && !tableIsLoading
                ? "highlight-first-row"
                : ""
            }
          >
            <PostmortemsTable
              dataLoading={tableIsLoading}
              tableData={dataForTable}
              setPg={setPg}
              setPgSize={updatePageSize}
              pg={pg}
              pgSize={pgSize}
              totalData={totalData}
              userAccessLoading={userAccessLoading}
              showPagination={true}
              userIsAdmin={userIsAdmin}
              callingFor={"ongoing"}
              sorting={handleSorting}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PostmortemsPage;
